/**
 * Frontend test-auth mode flags (#358 UI reachability smoke, Item A).
 *
 * CRA inlines process.env.REACT_APP_* at build time, so in any build where
 * REACT_APP_TEST_MODE is unset or not exactly the string 'true', TEST_MODE is
 * the constant `false` and every branch guarded by it is dead code — the mode
 * cannot activate at runtime.
 *
 * When TEST_MODE is true (local test builds only):
 * - the Clerk auth gate is bypassed (see auth/clerk.js), and
 * - api/client.js attaches X-Test-User-ID: TEST_USER_ID to every request,
 *   which the backend honors only when it runs with BRAINSTORMY_TEST_MODE=true
 *   (backend/middleware/test_auth.py).
 */
export const TEST_MODE = process.env.REACT_APP_TEST_MODE === 'true';
export const TEST_USER_ID = process.env.REACT_APP_TEST_USER_ID || '';
